import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';

export const getCountryCodes = (
	type: string
): Promise<string[]> => {
	return apiClient.get(
		`/public/${type}/distinct/countryCode`
	);
};

export const useCountryCodes = (type: string) => {
	const { data, isFetching, isFetched } = useQuery({
		queryKey: ['country-codes-' + type],
		queryFn: () => getCountryCodes(type),
		staleTime: 500,
	});

	const updateList = (countryCodes: string[]) =>
		countryCodes.reduce(
			(acc: string[], currentItem: string) => {
				acc.push(currentItem);

				return acc;
			},
			[]
		);

	return {
		data: data ? updateList(data) : [],
		isLoading: isFetching && !isFetched,
		isFetched,
	};
};
